import React from 'react'
import MaterialPage from './MaterialPage'

const MaterialContainer = () => {
    return (
        <div className='MaterialContainer'>
            <MaterialPage />
        </div>
    )
}

export default MaterialContainer